import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles/tailwind.less'
import * as serviceWorker from './serviceWorker'
import moment from 'moment'
import TagManager from 'react-gtm-module'
moment.locale('it')

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_TAG_MANAGER_ID,
  auth: process.env.REACT_APP_TAG_MANAGER_AUTH,
  dataLayerName: 'dataLayer'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
